<template>
  <div>{{startFrom}}s</div>
</template>

<script>
export default {
  props: ["start"],
  mounted() {
    const self = this;
    this.startFrom = this.start + 15;
    this.intervalID = window.setInterval(() => {
      self.decrement();
    }, 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.intervalID);
  },
  data() {
    return {
      startFrom: 0,
      intervalID: 0
    };
  },
  methods: {
    decrement() {
      this.startFrom = this.startFrom - 1;
      if (this.startFrom <= 0) {
        window.clearInterval(this.intervalID);
        this.$emit("action");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>